import { render } from "./EmailTemplateTest.vue?vue&type=template&id=8978612e&ts=true"
import script from "./EmailTemplateTest.vue?vue&type=script&lang=ts"
export * from "./EmailTemplateTest.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__